module.exports = __webpack_public_path__ + "static/media/hashnode.2a958b38.svg";